export const convertDateToLocalDate = (
  date: Date | undefined,
  formatter: (date: string) => string,
) => {
  if (!date) return undefined
  const formattedDate = formatter(date.toISOString())

  return new Date(formattedDate)
}
